/* eslint-disable camelcase */
import React, { useEffect, useState } from "react";
import { Dropdown, DropdownButton, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faArrowUpRightFromSquare,
  faMessage,
  faPen,
  faRotateLeft,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useGetBoomLogicWFMessagingDataQuery } from "../store/slices/widgetsSlice.ts";
import SearchIcon from "../../assets/icons/search.svg2";
import MyPagination from "../Common/MyPagination";

const columnOptions = [
  // { value: "Started", label: "Started" },
  { value: "Process", label: "Process" },
  { value: "Component", label: "Component" },
  { value: "Sent", label: "Sent" },
  { value: "Delivered", label: "Delivered" },
  { value: "Failed", label: "Failed" },
  { value: "Replies", label: "Replies" },
];

export default function BoomLogicWFMessaging({ showTransactions = true }) {
  const [inputText, setInputText] = useState("");
  const [search, setSearch] = useState("");
  const [order, setOrder] = useState("desc");
  const [order_by, setOrder_by] = useState("start_at");
  const [page, setPage] = useState(0);
  const [per_page, setPerPage] = useState(10);
  const [columnsToShow, setColumnsToShow] = useState(
    localStorage.getItem("WFMessagingOverviewColumns")
      ? JSON.parse(localStorage.getItem("WFMessagingOverviewColumns"))
      : ["report", "Process", "Started", "Component", "Sent", "Delivered"]
  );

  const { data = { components: [], total: 0 }, refetch } =
    useGetBoomLogicWFMessagingDataQuery({
      search,
      order,
      order_by,
      page,
      per_page,
    });

  // debounce
  useEffect(() => {
    const timeOut = setTimeout(() => {
      setSearch(inputText);
    }, 300);

    return () => {
      clearTimeout(timeOut);
    };
  }, [inputText]);

  return (
    <>
      <div className="d-flex justify-content-end mb-3 gap-3">
        <div className="position-relative  w-25">
          <input
            placeholder="Search"
            className="form-control"
            style={{ height: 38, paddingRight: 40 }}
            type="text"
            value={inputText}
            onChange={(e) => {
              setInputText(e.target.value);
            }}
          />
          <SearchIcon
            width={30}
            heigth={30}
            className="white bg-colored position-absolute top-50 end-0 translate-middle rounded-circle p-2"
            style={{ marginRight: -10 }}
          />
        </div>
        <DropdownButton
          id="show-colums-dropdown"
          title="Show columns"
          variant="colored"
          autoClose="outside"
          align="end"
          className="h-100 rounded-3"
        >
          {columnOptions.map((c) => (
            <Dropdown.Item as="div" key={c.value}>
              <Form.Check
                checked={columnsToShow.includes(c.value)}
                label={c.label}
                id={`${c.value}-checkbox`}
                onChange={() => {
                  setColumnsToShow((p) => {
                    let newColumns;
                    if (p.includes(c.value)) {
                      newColumns = p.filter((pc) => pc !== c.value);
                    } else {
                      newColumns = [...p, c.value];
                    }
                    localStorage.setItem(
                      "WFMessagingOverviewColumns",
                      JSON.stringify(newColumns)
                    );
                    return newColumns;
                  });
                }}
              />
            </Dropdown.Item>
          ))}
        </DropdownButton>
        <button
          type="button"
          className="btn btn-sm border-0"
          onClick={refetch}
          title="Refresh"
        >
          <FontAwesomeIcon icon={faRotateLeft} />
        </button>
      </div>
      <div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>
                <button
                  className="btn btn-link p-0"
                  type="button"
                  onClick={() => {
                    if (order_by !== "start_at") {
                      setOrder_by("start_at");
                      setOrder("desc");
                    } else {
                      setOrder((p) => (p === "asc" ? "desc" : "asc"));
                    }
                  }}
                >
                  Started
                  {order_by === "start_at" && (
                    <FontAwesomeIcon
                      className="ms-2"
                      icon={order === "asc" ? faAngleUp : faAngleDown}
                    />
                  )}
                </button>
              </th>

              {columnsToShow.includes("Process") && <th>Process</th>}
              {columnsToShow.includes("Component") && <th>Component</th>}
              {columnsToShow.includes("Sent") && (
                <th>
                  <button
                    className="btn btn-link p-0"
                    type="button"
                    onClick={() => {
                      if (order_by !== "dispatched") {
                        setOrder_by("dispatched");
                        setOrder("desc");
                      } else {
                        setOrder((p) => (p === "asc" ? "desc" : "asc"));
                      }
                    }}
                  >
                    Sent
                    {order_by === "dispatched" && (
                      <FontAwesomeIcon
                        className="ms-2"
                        icon={order === "asc" ? faAngleUp : faAngleDown}
                      />
                    )}
                  </button>
                </th>
              )}
              {columnsToShow.includes("Delivered") && (
                <th>
                  <button
                    className="btn btn-link p-0"
                    type="button"
                    onClick={() => {
                      if (order_by !== "delivered") {
                        setOrder_by("delivered");
                        setOrder("desc");
                      } else {
                        setOrder((p) => (p === "asc" ? "desc" : "asc"));
                      }
                    }}
                  >
                    Delivered
                    {order_by === "delivered" && (
                      <FontAwesomeIcon
                        className="ms-2"
                        icon={order === "asc" ? faAngleUp : faAngleDown}
                      />
                    )}
                  </button>
                </th>
              )}
              {columnsToShow.includes("Failed") && (
                <th>
                  <button
                    className="btn btn-link p-0"
                    type="button"
                    onClick={() => {
                      if (order_by !== "failed") {
                        setOrder_by("failed");
                        setOrder("desc");
                      } else {
                        setOrder((p) => (p === "asc" ? "desc" : "asc"));
                      }
                    }}
                  >
                    Failed
                    {order_by === "failed" && (
                      <FontAwesomeIcon
                        className="ms-2"
                        icon={order === "asc" ? faAngleUp : faAngleDown}
                      />
                    )}
                  </button>
                </th>
              )}
              {columnsToShow.includes("Replies") && (
                <th>
                  <button
                    className="btn btn-link p-0"
                    type="button"
                    onClick={() => {
                      if (order_by !== "replies") {
                        setOrder_by("replies");
                        setOrder("desc");
                      } else {
                        setOrder((p) => (p === "asc" ? "desc" : "asc"));
                      }
                    }}
                  >
                    Replies
                    {order_by === "replies" && (
                      <FontAwesomeIcon
                        className="ms-2"
                        icon={order === "asc" ? faAngleUp : faAngleDown}
                      />
                    )}
                  </button>
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {data.components.map((item, i) => (
              <tr key={i}>
                <td>
                  {new Date(item.process_started_at).toLocaleString()}{" "}
                  <Link
                    to={`/reporting/realtime/wf?projectUUID=${item.project_uuid}&startDate=${item.process_started_at}`}
                    className="ms-2"
                    title="View transactions"
                  >
                    <FontAwesomeIcon icon={faMessage} />
                  </Link>
                </td>

                {columnsToShow.includes("Process") && (
                  <td>
                    {item.process_guid}
                    <Link
                      to={`/reporting/processes/${item.project_id}/process/${item.process_id}`}
                      title="Open process details"
                      className="mx-2"
                    >
                      <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                    </Link>
                  </td>
                )}
                {columnsToShow.includes("Component") && (
                  <td>
                    {item.project_label}
                    <Link
                      to={`/library/logic/builder/${item.project_id}`}
                      className="mx-2"
                      title="Edit component"
                    >
                      <FontAwesomeIcon icon={faPen} />
                    </Link>
                  </td>
                )}
                {columnsToShow.includes("Sent") && <td>{item.dispatched}</td>}
                {columnsToShow.includes("Delivered") && (
                  <td>{item.delivered}</td>
                )}
                {columnsToShow.includes("Failed") && <td>{item.failed}</td>}
                {columnsToShow.includes("Replies") && <td>{item.replies}</td>}
              </tr>
            ))}
            {!data.components.length && (
              <tr>
                <td
                  className="text-center text-secondary"
                  colSpan={
                    1 +
                    columnOptions.filter((c) => columnsToShow.includes(c.value))
                      .length
                  }
                >
                  No component messaging found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <MyPagination
        total={data.total}
        onPaginate={(p, pp) => {
          setPage(p);
          setPerPage(pp);
        }}
        perPageOptions={[10, 25, 50]}
        defaultPerPage={10}
        alwaysVisible
      />
    </>
  );
}
